/**
 * Shared constants for Salesforce project paths and configuration
 */

/** Common Aura component locations in Salesforce projects */
export const AURA_SEARCH_PATHS = [
  'force-app/main/default/aura',
  'src/aura',
  'aura',
  'force-app/main/aura',
];

/** Common Visualforce page locations in Salesforce projects */
export const VF_PAGE_SEARCH_PATHS = [
  'force-app/main/default/pages',
  'src/pages',
  'pages',
  'force-app/main/pages',
];

/** Common Visualforce component locations in Salesforce projects */
export const VF_COMPONENT_SEARCH_PATHS = [
  'force-app/main/default/components',
  'src/components',
  'components',
  'force-app/main/components',
];

/** Common Apex controller locations */
export const APEX_SEARCH_PATHS = [
  'force-app/main/default/classes',
  'src/classes',
  'classes',
  'force-app/main/classes',
];
